import {
  homeQuotaNumStatistics,
  homeBusinessNumStatistics,
  homeQuotaNumStatistic,
  statisticsParentOrgQuota,
  alreadyWriteOffStatistics,
  pieBillingMethod,
  statisticsAdPositionNum,
  queryAdvertiserAndFlowMainNum,
  queryLaunchNumOfFlowMain,
  thirtyCouponStatisticsLine,
  thirtyCardStatisticsLine,
  queryThirtyLaunchNumLine
} from '@/api/sys.home'

export default {
  namespaced: true,
  actions: {
    homeQuotaNumStatistics ({
      dispatch
    }, {
      vm,
      data
    }) {
      return homeQuotaNumStatistics(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    homeBusinessNumStatistics ({
      dispatch
    }, {
      vm,
      data
    }) {
      return homeBusinessNumStatistics(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    homeQuotaNumStatistic ({
      dispatch
    }, {
      vm,
      data
    }) {
      return homeQuotaNumStatistic(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    statisticsParentOrgQuota ({
      dispatch
    }, {
      vm,
      data
    }) {
      return statisticsParentOrgQuota(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    alreadyWriteOffStatistics ({
      dispatch
    }, {
      vm,
      data
    }) {
      return alreadyWriteOffStatistics(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    pieBillingMethod ({
      dispatch
    }, {
      vm
    }) {
      return pieBillingMethod()
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    statisticsAdPositionNum ({
      dispatch
    }, {
      vm
    }) {
      return statisticsAdPositionNum()
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryAdvertiserAndFlowMainNum ({
      dispatch
    }, {
      vm
    }) {
      return queryAdvertiserAndFlowMainNum()
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryLaunchNumOfFlowMain ({
      dispatch
    }, {
      vm
    }) {
      return queryLaunchNumOfFlowMain()
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    thirtyCouponStatisticsLine ({
      dispatch
    }, {
      vm,
      data
    }) {
      return thirtyCouponStatisticsLine(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    thirtyCardStatisticsLine ({
      dispatch
    }, {
      vm,
      data
    }) {
      return thirtyCardStatisticsLine(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryThirtyLaunchNumLine ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryThirtyLaunchNumLine(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }

  }
}
